export const VERIFICATION_EULA_ENABLED = false;
export const HEADER_SEARCH_ENABLED = false;
export const SIGNUP_REFERRAL_CODE_ENABLED = false;
